import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';
import { generateColors } from '../../dashboard-helpers';

interface DataType {
  name: string[];
  count: number[];
}

export const useFrequentTasksByNodes = (): ChartProps => {
  const { list } = useDashboardStore();
  const data = list?.frequent_tasks as DataType;

  const chartData = useMemo<ReactApexChartProps>(() => {
    if (data) {
      const isDataExist = data.count.some((count) => count > 0);
      const labels = data.name;

      return {
        series: isDataExist ? data.count : [],
        options: {
          chart: {
            type: 'donut',
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          responsive: [
            {
              breakpoint: 1000,
              options: {
                legend: {
                  position: 'right',
                  verticalAlign: 'middle',
                  width: 150,
                  height: '100%',
                },
              },
            },
          ],
          labels,
          yaxis: {},
          xaxis: {},
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            enabled: true,
          },
          legend: {
            position: 'bottom',
            height: 120,
          },
          colors: generateColors(labels.length),
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [data]);

  return {
    series: chartData.series,
    options: chartData.options,
    label: 'Часто встречающиеся задачи',
    subLabel:
      'Диаграмма выделяет самые распространённые задачи, показывая, на какие типы работ стоит обратить особое внимание.',
    type: 'donut',
    wrapped: true,
  };
};
